module.exports = __webpack_public_path__ + "static/media/warning.61d5a722.svg";